// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3k9DO","icon":"SortAdornment_icon__2Y9WM","up":"SortAdornment_up__33nLE","down":"SortAdornment_down__1VJ3h","active":"SortAdornment_active__19DQ_"};